import React from 'react'
import { numberWithCommas } from '../../helpers/helpers'
import { FormattedData, State } from '../../types'
import { DirectionArrow } from '../shared/DirectionArrow'
import { DifferenceInCases, StyledGridTable } from './JabTracker.styled'
export function ActiveCasesTable({
    data,
    type,
}: {
    data: FormattedData
    type: 'large' | 'small'
}) {
    return (
        <>
            <StyledGridTable type={type}>
                {Object.keys(data).map((key) => {
                    const stateData = data[key as State]
                    const caseDirection =
                        stateData.cases.dailyDifference > 1 ? 'up' : 'down'
                    // Remove total count from list
                    if (key === 'AUS') {
                        return null
                    }
                    return (
                        <div className="StyledGridTable--FlexCell" key={key}>
                            <div className="StyledGridTable--StateKey">
                                {key}
                            </div>
                            <div className="StyledGridTable--Number">
                                {numberWithCommas(stateData.cases.dailyActive)}
                            </div>
                            {stateData.cases.dailyActive !== 0 && (
                                <DifferenceInCases
                                    type={type}
                                    direction={caseDirection}
                                >
                                    {DirectionArrow({
                                        direction: caseDirection,
                                    })}
                                    {stateData.cases.dailyDifference}
                                </DifferenceInCases>
                            )}
                        </div>
                    )
                })}
            </StyledGridTable>
        </>
    )
}
